module.exports = __webpack_public_path__ + "img/home-main.c23f7878.png";